<template>
  <img src="/focuz-logo.png" alt="" />
</template>
